import React, { ReactNode } from "react";
import { Modal, Button } from "@mantine/core";
import { IoWarningOutline } from "react-icons/io5";
import "./Modal.css";

type propsType = {
  openModal: boolean;
  handleClose: any;
  handleDelete: any;
  isLoading: boolean;
  targetName: string;
  isUsers?: boolean;
  desc?: ReactNode;
};
const DeleteModal = ({
  openModal,
  handleClose,
  handleDelete,
  isLoading,
  desc,
  targetName,
  isUsers = false,
}: propsType) => {
  return (
    <Modal
      opened={openModal}
      onClose={() => {
        handleClose();
      }}
      size="md"
      withCloseButton={false}
      radius={20}
    >
      <div className="flex flex-col  items-center px-2 py-4 ">
        <div className="flex items-center justify-center rounded-full w-14 h-14 bg-actionLight">
          <IoWarningOutline className="text-action text-3xl" />
        </div>
        <h4 className=" text-2xl font-medium mt-2 mb-1 text-grayText7">
          Are you sure ?
        </h4>

        {desc}

        <div className="flex gap-3 mt-4 flex-col w-full">
          <Button
            loading={isLoading}
            color={"#FB6514"}
            onClick={handleDelete}
            radius={"md"}
            size="md"
          >
            Delete
          </Button>
          <Button
            variant="default"
            radius={"md"}
            onClick={() => {
              handleClose();
            }}
            size="md"
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
